/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ContentEditorUploadedFileMapCreateResponse,
  UploadedFileCreate,
  UploadedFileCreate1,
  UploadedFileCreate2,
  UploadedFileCreateResponse,
  UploadedFileShowResponse,
  UploadedFileUpdate,
  UploadedFileUpdateResponse,
  UserMarketplaceProfileUploadedFileMapCreateResponse,
} from '../models';
import {
    ContentEditorUploadedFileMapCreateResponseFromJSON,
    ContentEditorUploadedFileMapCreateResponseToJSON,
    UploadedFileCreateFromJSON,
    UploadedFileCreateToJSON,
    UploadedFileCreate1FromJSON,
    UploadedFileCreate1ToJSON,
    UploadedFileCreate2FromJSON,
    UploadedFileCreate2ToJSON,
    UploadedFileCreateResponseFromJSON,
    UploadedFileCreateResponseToJSON,
    UploadedFileShowResponseFromJSON,
    UploadedFileShowResponseToJSON,
    UploadedFileUpdateFromJSON,
    UploadedFileUpdateToJSON,
    UploadedFileUpdateResponseFromJSON,
    UploadedFileUpdateResponseToJSON,
    UserMarketplaceProfileUploadedFileMapCreateResponseFromJSON,
    UserMarketplaceProfileUploadedFileMapCreateResponseToJSON,
} from '../models';

export interface CompanySpacesUsersUserIdMarketplaceProfileFilesIdGetRequest {
    userId: number;
    id: string;
    id2: string;
}

export interface CompanySpacesUsersUserIdMarketplaceProfileFilesPostRequest {
    userId: number;
    body?: UploadedFileCreate;
}

export interface ContentEditorElementsElementIdFilesIdDeleteRequest {
    elementId: number;
    id: string;
}

export interface ContentEditorElementsElementIdFilesIdGetRequest {
    elementId: number;
    id: string;
}

export interface ContentEditorElementsElementIdFilesIdPostRequest {
    elementId: number;
    id: string;
    body?: UploadedFileCreate2;
}

export interface ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdDeleteRequest {
    questionCatalogueId: number;
    questionId: number;
    choiceId: number;
    id: string;
}

export interface ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdGetRequest {
    questionCatalogueId: number;
    questionId: number;
    choiceId: number;
    id: string;
}

export interface ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdPostRequest {
    questionCatalogueId: number;
    questionId: number;
    choiceId: number;
    id: string;
    body?: UploadedFileCreate2;
}

export interface ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdDeleteRequest {
    questionCatalogueId: number;
    questionId: number;
    id: string;
}

export interface ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdGetRequest {
    questionCatalogueId: number;
    questionId: number;
    id: string;
}

export interface ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdPostRequest {
    questionCatalogueId: number;
    questionId: number;
    id: string;
    body?: UploadedFileCreate2;
}

export interface ContentEditorTestsChoicesChoiceIdFilesIdDeleteRequest {
    choiceId: number;
    id: string;
}

export interface ContentEditorTestsChoicesChoiceIdFilesIdGetRequest {
    choiceId: number;
    id: string;
}

export interface ContentEditorTestsChoicesChoiceIdFilesIdPostRequest {
    choiceId: number;
    id: string;
    body?: UploadedFileCreate2;
}

export interface ContentEditorTestsFilesIdDeleteRequest {
    id: string;
}

export interface ContentEditorTestsFilesIdGetRequest {
    id: string;
}

export interface ContentEditorTestsFilesIdPostRequest {
    id: string;
    body?: UploadedFileCreate2;
}

export interface ContentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdDeleteRequest {
    testId: number;
    questionId: number;
    choiceId: number;
    id: string;
}

export interface ContentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdGetRequest {
    testId: number;
    questionId: number;
    choiceId: number;
    id: string;
}

export interface ContentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdPostRequest {
    testId: number;
    questionId: number;
    choiceId: number;
    id: string;
    body?: UploadedFileCreate2;
}

export interface ContentEditorTestsTestIdQuestionsQuestionIdFilesIdDeleteRequest {
    testId: number;
    questionId: number;
    id: string;
}

export interface ContentEditorTestsTestIdQuestionsQuestionIdFilesIdGetRequest {
    testId: number;
    questionId: number;
    id: string;
}

export interface ContentEditorTestsTestIdQuestionsQuestionIdFilesIdPostRequest {
    testId: number;
    questionId: number;
    id: string;
    body?: UploadedFileCreate2;
}

export interface UploadedFilesIdPutRequest {
    id: string;
    body?: UploadedFileUpdate;
}

export interface UploadedFilesPostRequest {
    body?: UploadedFileCreate1;
}

/**
 * 
 */
export class UploadedFileApi extends runtime.BaseAPI {

    /**
     */
    async companySpacesUsersUserIdMarketplaceProfileFilesIdGetRaw(requestParameters: CompanySpacesUsersUserIdMarketplaceProfileFilesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadedFileShowResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling companySpacesUsersUserIdMarketplaceProfileFilesIdGet.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesUsersUserIdMarketplaceProfileFilesIdGet.');
        }

        if (requestParameters.id2 === null || requestParameters.id2 === undefined) {
            throw new runtime.RequiredError('id2','Required parameter requestParameters.id2 was null or undefined when calling companySpacesUsersUserIdMarketplaceProfileFilesIdGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.id2 !== undefined) {
            queryParameters['id'] = requestParameters.id2;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/users/{user_id}/marketplace_profile/files/{id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadedFileShowResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesUsersUserIdMarketplaceProfileFilesIdGet(requestParameters: CompanySpacesUsersUserIdMarketplaceProfileFilesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadedFileShowResponse> {
        const response = await this.companySpacesUsersUserIdMarketplaceProfileFilesIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesUsersUserIdMarketplaceProfileFilesPostRaw(requestParameters: CompanySpacesUsersUserIdMarketplaceProfileFilesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserMarketplaceProfileUploadedFileMapCreateResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling companySpacesUsersUserIdMarketplaceProfileFilesPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/users/{user_id}/marketplace_profile/files`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadedFileCreateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserMarketplaceProfileUploadedFileMapCreateResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesUsersUserIdMarketplaceProfileFilesPost(requestParameters: CompanySpacesUsersUserIdMarketplaceProfileFilesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserMarketplaceProfileUploadedFileMapCreateResponse> {
        const response = await this.companySpacesUsersUserIdMarketplaceProfileFilesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorElementsElementIdFilesIdDeleteRaw(requestParameters: ContentEditorElementsElementIdFilesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.elementId === null || requestParameters.elementId === undefined) {
            throw new runtime.RequiredError('elementId','Required parameter requestParameters.elementId was null or undefined when calling contentEditorElementsElementIdFilesIdDelete.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorElementsElementIdFilesIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/elements/{element_id}/files/{id}`.replace(`{${"element_id"}}`, encodeURIComponent(String(requestParameters.elementId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async contentEditorElementsElementIdFilesIdDelete(requestParameters: ContentEditorElementsElementIdFilesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contentEditorElementsElementIdFilesIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async contentEditorElementsElementIdFilesIdGetRaw(requestParameters: ContentEditorElementsElementIdFilesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadedFileShowResponse>> {
        if (requestParameters.elementId === null || requestParameters.elementId === undefined) {
            throw new runtime.RequiredError('elementId','Required parameter requestParameters.elementId was null or undefined when calling contentEditorElementsElementIdFilesIdGet.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorElementsElementIdFilesIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/elements/{element_id}/files/{id}`.replace(`{${"element_id"}}`, encodeURIComponent(String(requestParameters.elementId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadedFileShowResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorElementsElementIdFilesIdGet(requestParameters: ContentEditorElementsElementIdFilesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadedFileShowResponse> {
        const response = await this.contentEditorElementsElementIdFilesIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorElementsElementIdFilesIdPostRaw(requestParameters: ContentEditorElementsElementIdFilesIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentEditorUploadedFileMapCreateResponse>> {
        if (requestParameters.elementId === null || requestParameters.elementId === undefined) {
            throw new runtime.RequiredError('elementId','Required parameter requestParameters.elementId was null or undefined when calling contentEditorElementsElementIdFilesIdPost.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorElementsElementIdFilesIdPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/content_editor/elements/{element_id}/files/{id}`.replace(`{${"element_id"}}`, encodeURIComponent(String(requestParameters.elementId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadedFileCreate2ToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentEditorUploadedFileMapCreateResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorElementsElementIdFilesIdPost(requestParameters: ContentEditorElementsElementIdFilesIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentEditorUploadedFileMapCreateResponse> {
        const response = await this.contentEditorElementsElementIdFilesIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdDeleteRaw(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.questionCatalogueId === null || requestParameters.questionCatalogueId === undefined) {
            throw new runtime.RequiredError('questionCatalogueId','Required parameter requestParameters.questionCatalogueId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdDelete.');
        }

        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdDelete.');
        }

        if (requestParameters.choiceId === null || requestParameters.choiceId === undefined) {
            throw new runtime.RequiredError('choiceId','Required parameter requestParameters.choiceId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdDelete.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/question_catalogues/{question_catalogue_id}/questions/{question_id}/choices/{choice_id}/files/{id}`.replace(`{${"question_catalogue_id"}}`, encodeURIComponent(String(requestParameters.questionCatalogueId))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters.questionId))).replace(`{${"choice_id"}}`, encodeURIComponent(String(requestParameters.choiceId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdDelete(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdGetRaw(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadedFileShowResponse>> {
        if (requestParameters.questionCatalogueId === null || requestParameters.questionCatalogueId === undefined) {
            throw new runtime.RequiredError('questionCatalogueId','Required parameter requestParameters.questionCatalogueId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdGet.');
        }

        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdGet.');
        }

        if (requestParameters.choiceId === null || requestParameters.choiceId === undefined) {
            throw new runtime.RequiredError('choiceId','Required parameter requestParameters.choiceId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdGet.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/question_catalogues/{question_catalogue_id}/questions/{question_id}/choices/{choice_id}/files/{id}`.replace(`{${"question_catalogue_id"}}`, encodeURIComponent(String(requestParameters.questionCatalogueId))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters.questionId))).replace(`{${"choice_id"}}`, encodeURIComponent(String(requestParameters.choiceId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadedFileShowResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdGet(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadedFileShowResponse> {
        const response = await this.contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdPostRaw(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadedFileCreateResponse>> {
        if (requestParameters.questionCatalogueId === null || requestParameters.questionCatalogueId === undefined) {
            throw new runtime.RequiredError('questionCatalogueId','Required parameter requestParameters.questionCatalogueId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdPost.');
        }

        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdPost.');
        }

        if (requestParameters.choiceId === null || requestParameters.choiceId === undefined) {
            throw new runtime.RequiredError('choiceId','Required parameter requestParameters.choiceId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdPost.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/content_editor/question_catalogues/{question_catalogue_id}/questions/{question_id}/choices/{choice_id}/files/{id}`.replace(`{${"question_catalogue_id"}}`, encodeURIComponent(String(requestParameters.questionCatalogueId))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters.questionId))).replace(`{${"choice_id"}}`, encodeURIComponent(String(requestParameters.choiceId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadedFileCreate2ToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadedFileCreateResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdPost(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadedFileCreateResponse> {
        const response = await this.contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesChoiceIdFilesIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdDeleteRaw(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.questionCatalogueId === null || requestParameters.questionCatalogueId === undefined) {
            throw new runtime.RequiredError('questionCatalogueId','Required parameter requestParameters.questionCatalogueId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdDelete.');
        }

        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdDelete.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/question_catalogues/{question_catalogue_id}/questions/{question_id}/files/{id}`.replace(`{${"question_catalogue_id"}}`, encodeURIComponent(String(requestParameters.questionCatalogueId))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters.questionId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdDelete(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdGetRaw(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadedFileShowResponse>> {
        if (requestParameters.questionCatalogueId === null || requestParameters.questionCatalogueId === undefined) {
            throw new runtime.RequiredError('questionCatalogueId','Required parameter requestParameters.questionCatalogueId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdGet.');
        }

        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdGet.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/question_catalogues/{question_catalogue_id}/questions/{question_id}/files/{id}`.replace(`{${"question_catalogue_id"}}`, encodeURIComponent(String(requestParameters.questionCatalogueId))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters.questionId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadedFileShowResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdGet(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadedFileShowResponse> {
        const response = await this.contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdPostRaw(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadedFileCreateResponse>> {
        if (requestParameters.questionCatalogueId === null || requestParameters.questionCatalogueId === undefined) {
            throw new runtime.RequiredError('questionCatalogueId','Required parameter requestParameters.questionCatalogueId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdPost.');
        }

        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdPost.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/content_editor/question_catalogues/{question_catalogue_id}/questions/{question_id}/files/{id}`.replace(`{${"question_catalogue_id"}}`, encodeURIComponent(String(requestParameters.questionCatalogueId))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters.questionId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadedFileCreate2ToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadedFileCreateResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdPost(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadedFileCreateResponse> {
        const response = await this.contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdFilesIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorTestsChoicesChoiceIdFilesIdDeleteRaw(requestParameters: ContentEditorTestsChoicesChoiceIdFilesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.choiceId === null || requestParameters.choiceId === undefined) {
            throw new runtime.RequiredError('choiceId','Required parameter requestParameters.choiceId was null or undefined when calling contentEditorTestsChoicesChoiceIdFilesIdDelete.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorTestsChoicesChoiceIdFilesIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/tests/choices/{choice_id}/files/{id}`.replace(`{${"choice_id"}}`, encodeURIComponent(String(requestParameters.choiceId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async contentEditorTestsChoicesChoiceIdFilesIdDelete(requestParameters: ContentEditorTestsChoicesChoiceIdFilesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contentEditorTestsChoicesChoiceIdFilesIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async contentEditorTestsChoicesChoiceIdFilesIdGetRaw(requestParameters: ContentEditorTestsChoicesChoiceIdFilesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadedFileShowResponse>> {
        if (requestParameters.choiceId === null || requestParameters.choiceId === undefined) {
            throw new runtime.RequiredError('choiceId','Required parameter requestParameters.choiceId was null or undefined when calling contentEditorTestsChoicesChoiceIdFilesIdGet.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorTestsChoicesChoiceIdFilesIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/tests/choices/{choice_id}/files/{id}`.replace(`{${"choice_id"}}`, encodeURIComponent(String(requestParameters.choiceId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadedFileShowResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorTestsChoicesChoiceIdFilesIdGet(requestParameters: ContentEditorTestsChoicesChoiceIdFilesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadedFileShowResponse> {
        const response = await this.contentEditorTestsChoicesChoiceIdFilesIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorTestsChoicesChoiceIdFilesIdPostRaw(requestParameters: ContentEditorTestsChoicesChoiceIdFilesIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadedFileCreateResponse>> {
        if (requestParameters.choiceId === null || requestParameters.choiceId === undefined) {
            throw new runtime.RequiredError('choiceId','Required parameter requestParameters.choiceId was null or undefined when calling contentEditorTestsChoicesChoiceIdFilesIdPost.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorTestsChoicesChoiceIdFilesIdPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/content_editor/tests/choices/{choice_id}/files/{id}`.replace(`{${"choice_id"}}`, encodeURIComponent(String(requestParameters.choiceId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadedFileCreate2ToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadedFileCreateResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorTestsChoicesChoiceIdFilesIdPost(requestParameters: ContentEditorTestsChoicesChoiceIdFilesIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadedFileCreateResponse> {
        const response = await this.contentEditorTestsChoicesChoiceIdFilesIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorTestsFilesIdDeleteRaw(requestParameters: ContentEditorTestsFilesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorTestsFilesIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/tests/files/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async contentEditorTestsFilesIdDelete(requestParameters: ContentEditorTestsFilesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contentEditorTestsFilesIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async contentEditorTestsFilesIdGetRaw(requestParameters: ContentEditorTestsFilesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadedFileShowResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorTestsFilesIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/tests/files/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadedFileShowResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorTestsFilesIdGet(requestParameters: ContentEditorTestsFilesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadedFileShowResponse> {
        const response = await this.contentEditorTestsFilesIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorTestsFilesIdPostRaw(requestParameters: ContentEditorTestsFilesIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadedFileCreateResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorTestsFilesIdPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/content_editor/tests/files/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadedFileCreate2ToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadedFileCreateResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorTestsFilesIdPost(requestParameters: ContentEditorTestsFilesIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadedFileCreateResponse> {
        const response = await this.contentEditorTestsFilesIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdDeleteRaw(requestParameters: ContentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.testId === null || requestParameters.testId === undefined) {
            throw new runtime.RequiredError('testId','Required parameter requestParameters.testId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdDelete.');
        }

        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdDelete.');
        }

        if (requestParameters.choiceId === null || requestParameters.choiceId === undefined) {
            throw new runtime.RequiredError('choiceId','Required parameter requestParameters.choiceId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdDelete.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/tests/{test_id}/questions/{question_id}/choices/{choice_id}/files/{id}`.replace(`{${"test_id"}}`, encodeURIComponent(String(requestParameters.testId))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters.questionId))).replace(`{${"choice_id"}}`, encodeURIComponent(String(requestParameters.choiceId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdDelete(requestParameters: ContentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdGetRaw(requestParameters: ContentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadedFileShowResponse>> {
        if (requestParameters.testId === null || requestParameters.testId === undefined) {
            throw new runtime.RequiredError('testId','Required parameter requestParameters.testId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdGet.');
        }

        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdGet.');
        }

        if (requestParameters.choiceId === null || requestParameters.choiceId === undefined) {
            throw new runtime.RequiredError('choiceId','Required parameter requestParameters.choiceId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdGet.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/tests/{test_id}/questions/{question_id}/choices/{choice_id}/files/{id}`.replace(`{${"test_id"}}`, encodeURIComponent(String(requestParameters.testId))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters.questionId))).replace(`{${"choice_id"}}`, encodeURIComponent(String(requestParameters.choiceId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadedFileShowResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdGet(requestParameters: ContentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadedFileShowResponse> {
        const response = await this.contentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdPostRaw(requestParameters: ContentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadedFileCreateResponse>> {
        if (requestParameters.testId === null || requestParameters.testId === undefined) {
            throw new runtime.RequiredError('testId','Required parameter requestParameters.testId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdPost.');
        }

        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdPost.');
        }

        if (requestParameters.choiceId === null || requestParameters.choiceId === undefined) {
            throw new runtime.RequiredError('choiceId','Required parameter requestParameters.choiceId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdPost.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/content_editor/tests/{test_id}/questions/{question_id}/choices/{choice_id}/files/{id}`.replace(`{${"test_id"}}`, encodeURIComponent(String(requestParameters.testId))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters.questionId))).replace(`{${"choice_id"}}`, encodeURIComponent(String(requestParameters.choiceId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadedFileCreate2ToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadedFileCreateResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdPost(requestParameters: ContentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadedFileCreateResponse> {
        const response = await this.contentEditorTestsTestIdQuestionsQuestionIdChoicesChoiceIdFilesIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsQuestionIdFilesIdDeleteRaw(requestParameters: ContentEditorTestsTestIdQuestionsQuestionIdFilesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.testId === null || requestParameters.testId === undefined) {
            throw new runtime.RequiredError('testId','Required parameter requestParameters.testId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdFilesIdDelete.');
        }

        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdFilesIdDelete.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdFilesIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/tests/{test_id}/questions/{question_id}/files/{id}`.replace(`{${"test_id"}}`, encodeURIComponent(String(requestParameters.testId))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters.questionId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsQuestionIdFilesIdDelete(requestParameters: ContentEditorTestsTestIdQuestionsQuestionIdFilesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contentEditorTestsTestIdQuestionsQuestionIdFilesIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsQuestionIdFilesIdGetRaw(requestParameters: ContentEditorTestsTestIdQuestionsQuestionIdFilesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadedFileShowResponse>> {
        if (requestParameters.testId === null || requestParameters.testId === undefined) {
            throw new runtime.RequiredError('testId','Required parameter requestParameters.testId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdFilesIdGet.');
        }

        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdFilesIdGet.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdFilesIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/tests/{test_id}/questions/{question_id}/files/{id}`.replace(`{${"test_id"}}`, encodeURIComponent(String(requestParameters.testId))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters.questionId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadedFileShowResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsQuestionIdFilesIdGet(requestParameters: ContentEditorTestsTestIdQuestionsQuestionIdFilesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadedFileShowResponse> {
        const response = await this.contentEditorTestsTestIdQuestionsQuestionIdFilesIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsQuestionIdFilesIdPostRaw(requestParameters: ContentEditorTestsTestIdQuestionsQuestionIdFilesIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadedFileCreateResponse>> {
        if (requestParameters.testId === null || requestParameters.testId === undefined) {
            throw new runtime.RequiredError('testId','Required parameter requestParameters.testId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdFilesIdPost.');
        }

        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdFilesIdPost.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdFilesIdPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/content_editor/tests/{test_id}/questions/{question_id}/files/{id}`.replace(`{${"test_id"}}`, encodeURIComponent(String(requestParameters.testId))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters.questionId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadedFileCreate2ToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadedFileCreateResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsQuestionIdFilesIdPost(requestParameters: ContentEditorTestsTestIdQuestionsQuestionIdFilesIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadedFileCreateResponse> {
        const response = await this.contentEditorTestsTestIdQuestionsQuestionIdFilesIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async uploadedFilesIdPutRaw(requestParameters: UploadedFilesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadedFileUpdateResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling uploadedFilesIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/uploaded_files/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UploadedFileUpdateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadedFileUpdateResponseFromJSON(jsonValue));
    }

    /**
     */
    async uploadedFilesIdPut(requestParameters: UploadedFilesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadedFileUpdateResponse> {
        const response = await this.uploadedFilesIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async uploadedFilesPostRaw(requestParameters: UploadedFilesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadedFileCreateResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/uploaded_files`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadedFileCreate1ToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadedFileCreateResponseFromJSON(jsonValue));
    }

    /**
     */
    async uploadedFilesPost(requestParameters: UploadedFilesPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadedFileCreateResponse> {
        const response = await this.uploadedFilesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
